import { UnitMeasureType } from '~core/models/core.models';

export const UNIT_MEASURE_TYPE_OPTIONS: Record<UnitMeasureType, string> = {
  // Grandeurs fondamentales SI
  [UnitMeasureType.longueur]: 'Longueur',
  [UnitMeasureType.masse]: 'Masse',
  [UnitMeasureType.temps]: 'Temps',
  [UnitMeasureType.temperature]: 'Température',
  [UnitMeasureType.courantElectrique]: 'Courant électrique',
  [UnitMeasureType.quantiteDeMatiere]: 'Quantité de matière',
  [UnitMeasureType.intensiteLumineuse]: 'Intensité lumineuse',

  // Géométriques
  [UnitMeasureType.surface]: 'Surface',
  [UnitMeasureType.volume]: 'Volume',
  [UnitMeasureType.anglePlan]: 'Angle plan',
  [UnitMeasureType.angleSolide]: 'Angle solide',

  // Mécaniques
  [UnitMeasureType.vitesse]: 'Vitesse',
  [UnitMeasureType.vitesseAngulaire]: 'Vitesse angulaire',
  [UnitMeasureType.acceleration]: 'Accélération',
  [UnitMeasureType.force]: 'Force',
  [UnitMeasureType.pression]: 'Pression',
  [UnitMeasureType.energie]: 'Énergie',
  [UnitMeasureType.puissance]: 'Puissance',
  [UnitMeasureType.momentDeForce]: 'Moment de force',
  [UnitMeasureType.viscositeDynamique]: 'Viscosité dynamique',
  [UnitMeasureType.viscositeCinematique]: 'Viscosité cinématique',

  // Électriques
  [UnitMeasureType.tensionElectrique]: 'Tension électrique',
  [UnitMeasureType.resistanceElectrique]: 'Résistance électrique',
  [UnitMeasureType.chargeElectrique]: 'Charge électrique',
  [UnitMeasureType.capaciteElectrique]: 'Capacité électrique',
  [UnitMeasureType.inductance]: 'Inductance',
  [UnitMeasureType.conductanceElectrique]: 'Conductance électrique',
  [UnitMeasureType.puissanceApparente]: 'Puissance apparente',
  [UnitMeasureType.puissanceReactive]: 'Puissance réactive',

  // Magnétiques
  [UnitMeasureType.fluxMagnetique]: 'Flux magnétique',
  [UnitMeasureType.inductionMagnetique]: 'Induction magnétique',
  [UnitMeasureType.champMagnetique]: 'Champ magnétique',

  // Lumineuses
  [UnitMeasureType.fluxLumineux]: 'Flux lumineux',
  [UnitMeasureType.eclairementLumineux]: 'Éclairement lumineux',

  // Acoustiques
  [UnitMeasureType.niveauSonore]: 'Niveau sonore',

  // Fréquence & radioactivité
  [UnitMeasureType.frequence]: 'Fréquence',
  [UnitMeasureType.radioactivite]: 'Radioactivité',
  [UnitMeasureType.doseAbsorbee]: 'Dose absorbée',
  [UnitMeasureType.doseEquivalente]: 'Dose équivalente',

  // Données & quantités
  [UnitMeasureType.donneesNumeriques]: 'Données numériques',
  [UnitMeasureType.quantite]: 'Quantité',
  [UnitMeasureType.proportion]: 'Proportion'
};
